import React from "react";

function DropDown({ dropdownItems, show, handleClick }) {
  return (
    <div
      className={`absolute right-0  z-10 !rounded-full ${
        show ? "" : "hidden"
      } bg-white divide-y divide-gray-100  shadow-sm w-40`}
    >
      <ul className="py-2 text-sm text-white bg-gray-900">
        {dropdownItems?.map((item, index) => (
          <li key={index} onClick={() => handleClick(item)}>
            <div className="block px-4 py-2 hover:bg-[#2bace2]">{item}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DropDown;
